<template>
    <div>
        <h1 class="card-title h5">{{ $t('validationForm.headline.title.text') }}</h1>
        <!--<h2 class="card-subtitle h6">Hier können Sie Ihre Gutscheinnummer überprüfen und aktivieren, sowie eine Reservierung durchführen oder Ihren Gutschein umtauschen.</h2>-->
        <form class="form avp-form"
              role="form"
              autocomplete="off"
              @submit.prevent="validate" style="position: relative">
            <p>
                {{ $t('validationForm.supporting_text.intro.text') }}
            </p>
            <div class="form-group form-row align-items-center justify-content-center my-3">
                <div class="col-xs-12 col-sm-9 col-md-8 col-lg-7">
                    <input type="text"
                           ref="code"
                           class="form-control"
                           :placeholder="$t( 'validationForm.form.voucher_code.placeholder' )"
                           aria-describedby="gdpr-notice"
                           v-model="code"
                           required
                           autofocus
                    />
                </div>
                <div class="col-xs-12 col-sm-3 col-md-auto text-center mt-3 mt-sm-0">
                    <button type="submit"
                            class="btn btn-primary"
                            :disabled="isSubmitting"
                    >
                        {{ $t('validationForm.action.submit.text') }}
                    </button>
                </div>
            </div>
            <i18n path="validationForm.supporting_text.additional_information.text"
                  tag="small"
                  id="gdpr-notice"
                  class="form-text text-muted">
                <a :href=privacyUrl() target="_blank">
                    {{ $t('generic.data_protection') }}
                </a>
            </i18n>
        </form>

      <hr/>
      <template v-if="variant.key === 'animod'">
        <p class="text-center text-muted">
          {{ $t('validationForm.headline.novoucher.text') }}
          <br/>{{ $t('validationForm.headline.novoucher.text2', {brand: 'Animod'}) }}
        </p>
        <div class="align-items-center justify-content-center my-3">
          <div class="col-xs-12 col-sm-3 col-md-auto text-center mt-3 mt-sm-0">
            <a :href=shopUrl() class="btn btn-secondary btn-small">
              {{ $t('validationForm.action.novoucher.text') }}
            </a>
          </div>
        </div>
      </template>
      <template v-else-if="variant.key === 'kurzinurlaub'">
        <p class="text-center text-muted">
          {{ $t('validationForm.headline.novoucher.text') }}
          <br/>{{ $t('validationForm.headline.novoucher.text2', {brand: 'Kurz-in-Urlaub'}) }}
        </p>
        <div class="align-items-center justify-content-center my-3">
          <div class="col-xs-12 col-sm-3 col-md-auto text-center mt-3 mt-sm-0">
            <a :href=shopUrl() class="btn btn-secondary btn-small">
              {{ $t('validationForm.action.novoucher.text') }}
            </a>
          </div>
        </div>
      </template>
      <template v-else>
        <p class="text-center text-muted">
          Smartbox in Kooperation mit Animod
        </p>
      </template>
        <div v-if="!isCzechInstance">
            <p class="warning">
                <small>{{ $t('fraud.warning') }}</small>
            </p>
        </div>
    </div>
</template>
<style>
.warning {
    padding: 8px;
    border: 1px solid #ff8833;
}
</style>
<script>
    import { mapMutations } from 'vuex';
    import variations from "@/mixins/variations";

    export default {
        name: 'VoucherValidationForm',
        components: {
        },
        mixins: [variations],
        props: ['voucher'],
        data() {
            let isCzechInstance = location.hostname === 'voucher.animod.cz' || location.search.indexOf('czech=true') !== -1;
            return {
                codePattern: "",
                code: this.$route.query.code,
                token: "",
                errors: [],
                promise: null,
                isSubmitting: false,
                isCzechInstance: isCzechInstance
            }
        },
        methods: {
            ...mapMutations([
                'setLoading'
            ]),
            shopUrl() {
                return this.$i18n.t('voucherStatus.action.valuevoucher.link_buy_new.url');
            },
            reset() {
                this.code = "";
                this.errors = [];
            },
            validateCode() {
                console.log( "Validating voucher format" );
                if ( this.code.match( /^[0-9]{3}-[0-9]{3}-[0-9]{3}$/ ) !== null ) {
                    this.$refs.code.setCustomValidity(this.$i18n.t( 'validationForm.errors.voucher_code_mistaken.text' ));
                    return false;
                }
                return true;
            },
            privacyUrl() {
                return this.$i18n.t( 'validationForm.action.link_privacy.url' );
            },
            async validate() {
                this.isSubmitting = true;

                if (this.validateCode()) {
                    this.$refs.code.setCustomValidity("");

                    //this.setLoading(true);

                    this.submit();
                }
            },
            async submit() {
                const { code } = this;

                try {
                    const voucher = await this.$store.dispatch('validateCode', { code });
                }
                catch(e) {
                    //catching artificial response error, caused by unknown voucher
                }
                finally {
                    this.isSubmitting = false;
                }
            },
            onError(errors) {
                this.setLoading(false);
                console.error(...errors)
            },
        },
        created() {
            this.$store.dispatch('reset');
            if (this.$route.query.token) {
                this.$store.dispatch('fetchBookingDetailsToken', this.$route.query.token);
            }
        }
    }
</script>
